export default __webpack_public_path__ + "static/media/1-3.433c3670.jpg";